































































































import Vue from 'vue';
import moment from 'moment';
import { mapGetters } from 'vuex';
import { adjustColor, getAvatarURL } from '@/core/utils/utils';

export default Vue.extend({
  name: 'CommunityProfileMainData',
  props: {
    user: {
      type: Object as () => CommunityProfileResponse,
      default: null,
    },
    additionalUserInfo: {
      type: Object as () => CommunityProfileResponse,
      default: null,
    },
    size: {
      type: String,
      default: 'large',
    },
    showEditButton: {
      type: Boolean,
      default: true,
    },
    showBorder: {
      type: Boolean,
      default: false,
    },
    primaryColor: {
      type: String,
      default: '#000000',
    },
  },
  computed: {
    ...mapGetters({
      currentUser: 'user/user',
    }),
    registrationDate() {
      return this.getAdditionalUserInfo.created
        ? moment(this.getAdditionalUserInfo.created).format('ll')
        : null;
    },
    isCurrentUser() {
      return this.user.id === this.currentUser.community_profile_id;
    },
    getAdditionalUserInfo() {
      return this.additionalUserInfo || this.user;
    },
    userFullName() {
      return `${this.user?.first_name} ${this.user?.last_name}`;
    },
    userImage() {
      const color = 'white';
      const background = this.primaryColor;
      const fontSize = '48';
      const size = '120';

      return (
        this.user?.image ||
        getAvatarURL(this.userFullName, background, color, fontSize, size)
      );
    },
  },
  methods: {
    redirectToEditProfile() {
      this.$router.push({
        name: 'student-community-profile-edit',
      });
    },
  },
});
